
const LOAD_GOOGLE_API = "loadGoogleApi";
const LOADED_GOOGLE_API = "loadedGoogleApi";
const LOAD_USER_PROFILE = "loadUserProfile";
export const LOADED_USED_PROFILE = "loadedUserProfile";
const RESET_USER = "resetUser";

import GoogleMapsApiLoader from "google-maps-api-loader";
const API_KEY = "AIzaSyDeo7dwJxuCdt6RRhvEeUpHgeCZ6qXtljU";
import {getUserProfile} from "../apis/security_apis"

const globalState = {
    googleApi: null,
    initializing: false,
    initializintErrors: "",
    user: {},
    loadingUser: false,
    userLoadErrors: "",
}

const mutations = {
    [LOAD_GOOGLE_API] (state) {
        Object.assign(state, {initializing: true});
    },
    [LOADED_GOOGLE_API] (state, payload) {
        Object.assign(state, {...payload})
    },
    [LOAD_USER_PROFILE] (state) {
        Object.assign(state, {loadingUser: true});
    },
    [LOADED_USED_PROFILE] (state, payload) {
        Object.assign(state, {...payload})
    },
    [RESET_USER] (state) {
        Object.assign(state, {user: {}})
    },

}

const actions = {
    initializeGoogleApi({commit, state}) {


        if(state.googleApi || state.initializing){
           return;
        }

        commit(LOAD_GOOGLE_API);

        GoogleMapsApiLoader({
            libraries: ['places'],
            apiKey: API_KEY
        }).then( googleApi => {
            commit(LOADED_GOOGLE_API, {googleApi, initializing: false});
        }, error => {
            commit(LOADED_GOOGLE_API, {googleApi: null, initializintErrors: "Failed to initialize", initializing: false});
            // eslint-disable-next-line no-console
            console.error(error);
        })

    },
    getUserProfile({commit}, callback) {

        commit(LOAD_USER_PROFILE);
        getUserProfile().then( user => {
            commit(LOADED_USED_PROFILE, {user, initializing: false});
            callback();
        }, () => {
            commit(LOADED_USED_PROFILE, {user: {}, userLoadErrors: "Failed to validate user", loadingUser: false});
            callback();
        })

    },
    resetUser({commit}) {
        commit(RESET_USER);
    }
}


export default {
    state: globalState,
    mutations,
    actions
}
